import NewProductPage from './new-product-page';

export default NewProductPage;